import makeStyles from '@mui/styles/makeStyles';
import { SIDEBAR_STEP_MAX_WIDTH } from '../../../helpers/constants';
import { stepContainer } from '../ui/styles';

export const createClasses = makeStyles(theme => ({
  container: {
    ...stepContainer(theme),
    maxWidth: SIDEBAR_STEP_MAX_WIDTH
  },
  image: {
    width: theme.spacing(22),
    height: theme.spacing(22),
    alignSelf: 'center'
  },
  title: {
    fontWeight: 600,
    textAlign: 'center'
  },
  body: {
    color: theme.palette.text.secondary,
    textAlign: 'center'
  },
  actionButton: {
    alignSelf: 'center',
    marginTop: theme.spacing(1)
  }
}));
